<template>
  <div>
    <v-btn
      v-if="!$vuetify.breakpoint.xsOnly"
      text rounded
      @click.stop.prevent="$router.go(-1)">
      <v-icon left>fas fa-angle-left</v-icon>
      <span
        v-if="!hideLabel"
        class="hidden-xs-only body-2 font-weight-medium"
        >Back</span>
    </v-btn>
    <v-btn
      v-else
      color="secondary"
      icon
      
      @click.stop.prevent="$router.go(-1)"
    >
      <v-icon>fas fa-angle-left</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: ['hideLabel'],
  name: 'back-button',
};
</script>
